// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake"}[chunkId] || chunkId) + "." + {"102":"35a8d8f9","133":"b793856b","223":"a12e64d8","488":"7bc787be"}[chunkId] + ".chunk.js";
};